import get from 'lodash/get';
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';

import Button from '../../../Button';
import ErrorBlock from '../../../common/ErrorBlock';
import DateDropdown from '../../../common/DateDropdown';

import { ERROR_CODES } from './helpers';

import useJoinFormTitles from './hooks/useJoinFormTitles';
import useHandleGlobalPaperworkPending from '../../hooks/useHandleGlobalPaperworkPending';

import { actions as paperworkVerifyDobActions } from '../../../../redux/paperwork/requests/paperwork-verify-dob';
import {
  selectPaperworkVerifyDobPending,
  selectPaperworkVerifyDobError,
} from '../../../../redux/paperwork/selectors/paperwork-verify-dob';

import TermsAndPolicies from '../../../common/TermsAndPolicies';
import { privacyListSelector } from '../../../../redux/data/selectors';
import { DEFAULT_COUNTRY } from '../../../../constants';

import styles from './styles.module.styl';

const JoinForm = ({ params }) => {
  const [dateOfBirth, setDateOfBirth] = useState(null);

  const { formatMessage } = useIntl();

  const dispatch = useDispatch();

  const verifyDobPending = useSelector(selectPaperworkVerifyDobPending);

  const verifyDobError = useSelector(selectPaperworkVerifyDobError);

  const privacyList = useSelector(privacyListSelector);

  const appointmentUUID = get(params, 'uuid', '');

  const {
    title,
    descriptionText,
    confirmButtonText,
    agreeWithTermsAndPolicyText,
    termOfUseText,
    privacyText,
  } = useJoinFormTitles();

  useHandleGlobalPaperworkPending(verifyDobPending);

  const privacyByCountry = useMemo(
    () => privacyList.find(item => item.country === DEFAULT_COUNTRY) || {},
    [privacyList],
  );

  const errorMessage = useMemo(() => {
    const errorCode = get(verifyDobError, 'code');

    if (!errorCode) return '';

    const errorText = ERROR_CODES[errorCode] || 'errors.common';

    return formatMessage({ id: errorText });
  }, [verifyDobError]);

  const confirmDob = () => {
    dispatch(
      paperworkVerifyDobActions.send({
        dob: dateOfBirth,
        appointmentUUID,
      }),
    );
  };

  return (
    <section className={styles.root}>
      <div className={styles.form}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.text}>{descriptionText}</p>

        <div className={styles.inputWrapper}>
          {verifyDobError && (
            <ErrorBlock className={styles.error} errors={errorMessage} />
          )}
          <DateDropdown
            value={dateOfBirth}
            onChange={setDateOfBirth}
            labelMessageId="paperwork.dob.fieldLabel"
          />
        </div>

        <Button
          raised
          color="primary"
          onClick={confirmDob}
          className={styles.button}
          disabled={!dateOfBirth || verifyDobPending}
        >
          {confirmButtonText}
        </Button>

        <div className={styles.termsAndPoliciesWrapper}>
          {agreeWithTermsAndPolicyText({
            terms: (
              <TermsAndPolicies
                className={styles.termsAndPolicies}
                textLink={termOfUseText}
                document={privacyByCountry.terms}
              />
            ),
            policy: (
              <TermsAndPolicies
                className={styles.termsAndPolicies}
                textLink={privacyText}
                document={privacyByCountry.privacyPolicy}
              />
            ),
          })}
        </div>
      </div>
    </section>
  );
};

JoinForm.propTypes = {
  params: PropTypes.object,
};

export default withRouter(JoinForm);



// WEBPACK FOOTER //
// ./src/components/Paperwork/components/JoinForm/index.jsx